import React from 'react';
import styles from './CalculatorDisclaimerModal.module.scss';
import {ESTIMATED_RATE_OF_RETURN} from "../../../redux/modules/modals/modals.module";
import ButtonBeacon from "../../Beacon/ButtonBeacon";
const EstimatedRateOfReturnModal = ({onClose}) => {
  return (
    <div className={styles["container"]}>
      <h1 className={styles["title"]}>What is an estimated rate of return?</h1>
      <div className={styles["sub-title"]}>
        <p>
          A rate of return is the gain or loss of an investment over a specified time period,
          compared to the initial investment. We use the estimated rate of return to help project
          your future account balances, which will impact the calculation of your estimated RMD.
        </p>
        <p>
          The default value for annual rate of return is 5.5%. This value is for illustrative purposes
          only and is not guaranteed. Your actual rate of return is largely dependent on the types of
          investments in your portfolio and your investment strategy.
        </p>
        <p>
          You may change the estimated rate of return from the default value to one more aligned with your
          situation and the allocation of assets in the investments subject to RMD. Your actual investment
          performance will vary and may produce higher or lower returns, especially in the long term. Investments
          that pay higher rates of return are generally subject to higher risk and volatility. Many people seek to
          invest in securities with a lower level of risk and return as they approach or are in retirement.
        </p>
      </div>
      <div>
        <div className={styles["buttonModal"]}>
          <div className={styles["button-object"]}>
            <ButtonBeacon onClick={() => onClose(ESTIMATED_RATE_OF_RETURN)} label={'Close'} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EstimatedRateOfReturnModal;
